import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import ProgressBar from "@ramonak/react-progress-bar";
import TopNav from "../components/common/topnav.component";
import { TabView, TabPanel } from 'primereact/tabview';
import CaretarrowUp from '../assets/images/caret-arrow-up.png';
import CaretarrowDown from '../assets/images/caret-down.png';
import TreadingarrowUp from '../assets/images/treading-arrow-up.png';
import TreadingarrowDown from '../assets/images/treading-arrow-down.png';
import StrictdressCode from '../assets/images/strict-dress-code.svg';
import ControlledaccessSchools from '../assets/images/controlled-access-to-schools.svg';
import FacultyBadges from '../assets/images/faculty-badges.svg';
import RandomdogSniff from '../assets/images/random-dog-sniff.svg';
import StudentIDs from '../assets/images/student-IDs.svg';
import SecurityCameras from '../assets/images/security-cameras.svg';
import MetaldetectorChecks from '../assets/images/metal-detector-checks.svg';
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDistrict_Climate_Rating, fetchstudent_behavior_poor_performing_schools, fetchstudent_behavior_top_performing_schools,
  fetchStudent_Behavior_Incident_Type, fetchStudent_Behavior_Chart
} from '../redux/slices/studentbehavior';
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { Tooltip } from "primereact/tooltip";
import ValueTooltip from "../components/Tooltip/valueTooltip";

const MediumLevel = {
  tooltip: {},
  legend: {
    top: '10',
    left: '10',
    icon: "circle",
    width: '400',
    textStyle: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: 10
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    top: '0%',
    width: '105%',
    height: '200%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: {
    type: 'category',
    // data: ['2018 534' ],
    show: false
  },
  series: [
    {
      name: 'Bord L2',
      type: 'bar',
      barGap: '-100%',
      color: '#8a2c6a',
      barWidth: '20px',
      z: 10,
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [240]
    },
    {
      name: 'Inappropriate Conduct (L2) 2018:656',
      type: 'bar',
      color: '#687ecd',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [656]
    }
  ]
};




const MajorSeverity = {
  tooltip: {},
  legend: {
    top: '10',
    left: '10',
    icon: "circle",
    width: '400',
    textStyle: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: 10
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    top: '0%',
    width: '100%',
    height: '200%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: {
    type: 'category',
    // data: ['2018 534' ],
    show: false
  },
  series: [
    {
      name: 'Bd Emp (L3)',
      type: 'bar',
      color: '#8a2c6a',
      barGap: '-100%',
      z: 10,
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [40]
    },
    {
      name: 'Tabacco (S3)',
      type: 'bar',
      color: '#129c83',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [800]
    },
    {
      name: 'Inapprop use of technology (L3)',
      type: 'bar',
      color: '#5470c6',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [200]
    }
  ]
};


const MajorseverityArea = {
  title: {
    text: '',
    left: 10,
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
  },
  color: ['#892c69'],
  tooltip: {
    backgroundColor: 'rgba(50,50,50,0.7)',
    borderColor: "#333",
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
    trigger: 'axis',
    axisPointer: {
      type: 'line',
      lineStyle: {
        type: "line"
      }
    }
  },
  grid: {
    tooltip: {
      padding: [100, 100, 100, 100],
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      color: '#fff'
    }
  },

  grid: {
    right: '0%',
    bottom: '0%',
    // top: '-15%',
    width: '128%',
    height: '320%',
    left: '-22%'
  },

  yAxis: [
    {
      type: 'value',
      show: false,
      axisLine: {
        show: false,
        lineStyle: {
          color: '#E0E0E0'
        }
      },
      axisLabel: {
        show: false,
        color: '#4F4F4F'
      },
      splitLine: {
        lineStyle: {
          show: false,
          type: "dashed"
        },
      },
      min: 0,
      max: 100000,
      interval: 1000,
    },
  ],
  xAxis: {
    type: 'category',
    data: ['2015', '2016', '2017', '2018'],
    position: "bottom",
    show: false,
    offset: -30,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: '#2b3e8b'
      }
    },
    axisLabel: {
      inside: true,
      color: '#fff'
    },
    z: 10
  },
  series: [
    {
      data: [21600, 20743, 19431, 15000, 15000],
      type: 'line',
      areaStyle: {},
      color: '#2b3e8b',
      label: {
        show: true,
        position: 'top',
        textShadowBlur: false,
        color: '#fff'
      },

    },
  ]
};

const Minorclassroom = {
  tooltip: {},
  legend: {
    top: '10',
    left: '10',
    icon: "circle",
    width: '400',
    textStyle: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: 10
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    top: '0%',
    width: '100%',
    height: '200%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: {
    type: 'category',
    // data: ['2018 534' ],
    show: false
  },
  series: [
    {
      name: 'Tobacco (S3)',
      type: 'bar',
      color: '#8a2c6a',
      barWidth: '20px',
      barGap: '-100%',
      z: 10,
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    },
    {
      name: 'Bd Emp (L3)',
      type: 'bar',
      color: '#5470c6',
      z: 9,
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    },
    {
      name: 'Inapprop use of Technology (L3)',
      type: 'bar',
      color: '#129b82',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    }
  ]
};

const MinorSeverity = {
  tooltip: {},
  legend: {
    top: '10',
    left: '10',
    icon: "circle",
    width: '400',
    textStyle: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: 8
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    top: '0%',
    width: '100%',
    height: '200%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: {
    type: 'category',
    // data: ['2018 534' ],
    show: false
  },
  series: [
    {
      name: 'Violation of Classroom Rule (L1)',
      type: 'bar',
      color: '#8a2c6a',
      barWidth: '20px',
      barGap: '-100%',
      z: 10,
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [700]
    },
    {
      name: 'Tardy (L1)',
      type: 'bar',
      color: '#5470c6',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    },
    {
      name: 'Skip School-Not on campus (L2)',
      type: 'bar',
      color: '#129b82',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [0]
    }
  ]
};

const MinorSeverityArea = {
  title: {
    text: '',
    left: 10,
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
  },
  color: ['#892c69'],
  tooltip: {
    backgroundColor: 'rgba(50,50,50,0.7)',
    borderColor: "#333",
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
    trigger: 'axis',
    axisPointer: {
      type: 'line',
      lineStyle: {
        type: "line"
      }
    }
  },
  grid: {
    tooltip: {
      padding: [100, 100, 100, 100],
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      color: '#fff'
    }
  },

  grid: {
    right: '0%',
    bottom: '0%',
    // top: '-15%',
    width: '200%',
    height: '650%',
    left: '-25%'
  },

  yAxis: [
    {
      type: 'value',
      show: false,
      axisLine: {
        show: false,
        lineStyle: {
          color: '#E0E0E0'
        }
      },
      axisLabel: {
        show: false,
        color: '#4F4F4F'
      },
      splitLine: {
        lineStyle: {
          show: false,
          type: "dashed"
        },
      },
      min: 0,
      max: 100000,
      interval: 1000,
    },
  ],
  xAxis: {
    type: 'category',
    data: ['2015', '2016', '2017', '2018'],
    position: "bottom",
    show: false,
    offset: -30,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: '#2b3e8b'
      }
    },
    axisLabel: {
      inside: true,
      color: '#fff'
    },
    z: 10
  },
  series: [
    {
      data: [9140, 9140, 9140, 9140],
      type: 'line',
      areaStyle: {},
      color: '#2b3e8b',
      label: {
        show: true,
        position: 'top',
        textShadowBlur: false,
        color: '#fff'
      },

    },
  ]
};

const Severeseverity = {
  tooltip: {},
  legend: {
    top: '10',
    left: '10',
    icon: "circle",
    width: '400',
    textStyle: {
      color: "rgba(255, 255, 255, 1)",
      fontSize: 10
    }
  },
  grid: {
    left: '0%',
    right: '0%',
    bottom: '3%',
    top: '0%',
    width: '100%',
    height: '200%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    show: false
  },
  yAxis: {
    type: 'category',
    // data: ['2018 534' ],
    show: false
  },
  series: [
    {
      name: 'Drug Use Possess; exc alc (S4)',
      type: 'bar',
      color: '#8a2c6a',
      barWidth: '20px',
      barGap: '-100%',
      z: 10,
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    },
    {
      name: '',
      type: 'bar',
      color: '#129b82',
      barWidth: '20px',
      itemStyle: {
        emphasis: {
          barBorderRadius: [50, 50]
        },
        normal: {
          barBorderRadius: [50, 50, 50, 50]
        }
      },
      label: {
        show: false
      },
      emphasis: {
        focus: 'series'
      },
      data: [1000]
    }
  ]
};

const SevereseverityArea = {
  title: {
    text: '',
    left: 10,
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
  },
  color: ['#892c69'],
  tooltip: {
    backgroundColor: 'rgba(50,50,50,0.7)',
    borderColor: "#333",
    textStyle: {
      fontSize: 12,
      fontWeight: "normal",
      color: '#fff',
    },
    trigger: 'axis',
    axisPointer: {
      type: 'line',
      lineStyle: {
        type: "line"
      }
    }
  },
  grid: {
    tooltip: {
      padding: [100, 100, 100, 100],
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      color: '#fff'
    }
  },

  grid: {
    right: '0%',
    bottom: '0%',
    // top: '-15%',
    width: '125%',
    height: '385%',
    left: '-22%'
  },

  yAxis: [
    {
      type: 'value',
      show: false,
      axisLine: {
        show: false,
        lineStyle: {
          color: '#E0E0E0'
        }
      },
      axisLabel: {
        show: false,
        color: '#4F4F4F'
      },
      splitLine: {
        lineStyle: {
          show: false,
          type: "dashed"
        },
      },
      min: 0,
      max: 1000,
      interval: 200,
    },
  ],
  xAxis: {
    type: 'category',
    data: ['2015', '2016', '2017', '2018'],
    position: "bottom",
    show: false,
    offset: -30,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: '#2b3e8b'
      }
    },
    axisLabel: {
      inside: true,
      color: '#fff'
    },
    z: 10
  },
  series: [
    {
      data: [150, 221, 150, 150, 215],
      type: 'line',
      areaStyle: {},
      color: '#2b3e8b',
      label: {
        show: false,
        position: 'top',
        textShadowBlur: false,
        color: '#000'
      },

    },
  ]
};





export default function Studentbehaviour(props) {
  const dispatch = useDispatch();
  const District_Climate_Ratingdata = useSelector(state => state.studentbehavior.District_Climate_Rating);
  const District_Climate_RatingLoading = useSelector(state => state.studentbehavior.District_Climate_Ratingloading);
  const student_behavior_poor_performing_schoolsdata = useSelector(state => state.studentbehavior.student_behavior_poor_performing_schools);
  const student_behavior_top_performing_schoolsdata = useSelector(state => state.studentbehavior.student_behavior_top_performing_schools);
  const student_behavior_top_performing_schoolsloading = useSelector(state => state.studentbehavior.student_behavior_top_performing_schoolsloading);
  const Student_Behavior_Incident_Typedata = useSelector(state => state.studentbehavior.Student_Behavior_Incident_Type);
  const Student_Behavior_Incident_Typeloading = useSelector(state => state.studentbehavior.Student_Behavior_Incident_Typeloading);
  const Student_Behavior_Chartdata = useSelector(state => state.studentbehavior.Student_Behavior_Chart);

  const IncidentsOrder = ['# of Incidents - Level1', '# of Incidents - Level2', '# of Incidents - Level3', '# of Incidents - Level4', '# of Incidents - Level5', '# of Incidents - Level6'];

  const Student_Behavior_Incident_TypedataSorted = [...Student_Behavior_Incident_Typedata]?.sort((a, b) => {
    return IncidentsOrder.indexOf(a.METRIC_NAME) - IncidentsOrder.indexOf(b.METRIC_NAME);
  })
  useEffect(() => {
    dispatch(fetchDistrict_Climate_Rating({
      "elasticQueryName": "District_Climate_Rating",
      "filters": [{
        "columnName": "SCHOOL_YEAR",
        "columnValue": ["2027"], "excludeKeyword": false
      }],
      "dynamicColumns": [],
    }));

    dispatch(fetchstudent_behavior_poor_performing_schools({
      "elasticQueryName": "student_behavior_poor_performing_schools",
      "filters": [{
        "columnName": "SCHOOL_YEAR",
        "columnValue": ["2027"], "excludeKeyword": false
      }],
      "dynamicColumns": [],
    }));

    dispatch(fetchstudent_behavior_top_performing_schools({
      "elasticQueryName": "student_behavior_top_performing_schools",
      "filters": [{
        "columnName": "SCHOOL_YEAR",
        "columnValue": ["2027"], "excludeKeyword": false
      }],
      "dynamicColumns": [],
    }));

    dispatch(fetchStudent_Behavior_Incident_Type({
      "elasticQueryName": "Student_Behavior_Incident_Type",
      "filters": [{
        "columnName": "SCHOOL_YEAR",
        "columnValue": ["2027"], "excludeKeyword": false
      }],
      "dynamicColumns": [],
    }));

    dispatch(fetchStudent_Behavior_Chart({
      "elasticQueryName": "Student_Behavior_Chart",
      "filters": [],
      "dynamicColumns": [],
    }));
  }, [])

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(student_behavior_poor_performing_schoolsdata?.length / itemsPerPage);

  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(student_behavior_top_performing_schoolsdata?.length / itemsPerPage);

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePageChange = (event) => {
    setCurrentPage(parseInt(event.target.value));
  };

  const handlePrevPage1 = () => {
    setCurrentPage1((prevPage) => prevPage - 1);
  };

  const handleNextPage1 = () => {
    setCurrentPage1((prevPage) => prevPage + 1);
  };

  const handlePageChange1 = (event) => {
    setCurrentPage1(parseInt(event.target.value));
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = student_behavior_poor_performing_schoolsdata?.slice(startIndex, endIndex);

  const startIndex1 = (currentPage1 - 1) * itemsPerPage;
  const endIndex1 = startIndex1 + itemsPerPage;
  const currentData1 = student_behavior_top_performing_schoolsdata?.slice(startIndex1, endIndex1);
  var Student_Behavior_Chartdatanew = JSON.parse(JSON.stringify(Student_Behavior_Chartdata));

  let merticname = [];
  if (Student_Behavior_Incident_Typedata) {
    for (let o = 0; o < Student_Behavior_Incident_Typedata.length; o++) {
      merticname.push(Student_Behavior_Incident_Typedata[o].METRIC_NAME)
    }
  }
  const merticnamedum = [...new Set(merticname)];


  const dum = merticnamedum;
  function generateChartConfig(data, metric, color = '#892c69', labelColor = '#FFD700') {
    const filteredData = data
      .filter(itr => itr.METRIC_NAME === metric)
      .sort((a, b) => a.SCHOOL_YEAR - b.SCHOOL_YEAR);

    const xAxisData = filteredData.map(itr => itr.SCHOOL_YEAR);
    const seriesData = filteredData.map(itr => itr.NUMERATOR);

    return {
      title: {
        text: '',
        left: 10,
        textStyle: {
          fontSize: 12,
          fontWeight: "normal",
          color: '#fff',
        },
      },
      color: [color],
      tooltip: {
        backgroundColor: 'rgba(50,50,50,0.7)',
        borderColor: "#333",
        textStyle: {
          fontSize: 12,
          fontWeight: "normal",
          color: '#fff',
        },
        trigger: 'axis',
        axisPointer: {
          type: 'line',
          lineStyle: {
            type: "line"
          }
        }
      },
      grid: {
        bottom: '10%',
        left: '0%',
        containLabel: true
      },
      yAxis: [
        {
          type: 'value',
          show: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: '#E0E0E0'
            }
          },
          axisLabel: {
            show: false,
            color: '#4F4F4F'
          },
          splitLine: {
            lineStyle: {
              show: false,
              type: "dashed"
            },
          },
        },
      ],
      xAxis: {
        type: 'category',
        data: xAxisData,
        show: true,
        offset: 20,
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#2b3e8b'
          }
        },
        axisLabel: {
          inside: true,
          color: labelColor
        },
        z: 10
      },
      series: [
        {
          data: seriesData,
          type: 'line',
          areaStyle: {},
          color: '#B55D5D',
          label: {
            show: true,
            position: 'top',
            textShadowBlur: false,
            color: '#fff'
          },
        },
      ]
    };
  }

  // Example Usage

  const TooltipAttributes = ({ categoryLabel }) => {
    return {
      'data-pr-tooltip': `Variance from Last Year ${categoryLabel?.toFixed(0)}`,
      'data-pr-position': 'top',
      'data-pr-my': 'left-40 bottom',
      'data-pr-at': 'center top-5',
      // 'data-pr-className': 'custom-tooltip',
      style: { cursor: 'pointer' }
    }
  }
  const TooltipAttributes1 = ({ Description }) => {
    return {
      'data-pr-tooltip': `${Description}`,
      'data-pr-position': 'top',
      'data-pr-my': 'left-40 bottom',
      'data-pr-at': 'center top-5',
      // 'data-pr-className': 'custom-tooltip',
      style: { cursor: 'pointer' }
    }
  }

  const IncidentDescription = [
    "# of students with unexcused absences from class or school.",
    "# of students who refused to follow directions or challenged staff authority.",
    "# of students involved in behavior that interrupted instruction or the learning environment.",
    "# of students involved in physical conflict such as hitting, pushing, or grabbing.",
    "# of students who misused electronic devices during school hours.",
    "# of students involved in incidents that do not fit into any defined category.",
  ]

  return (
    <div className='body'>
      <TopNav pagename="Student Behavior" pagenamedescription="Key Facts about the District" setUserData={props.setUserData} />
      <AppliedFilters pagename={"Student Behavior"}/>
      <div className='district-Neighborhood mx-4 my-4'>
        <div className='grid grid-cols-12 gap-4'>
          <div className='col-span-4 lg:col-span-4 md:col-span-6 sm:col-span-12 max-sm:col-span-12'>
            <LoaderContainer loading={District_Climate_RatingLoading} height={"100px"} width={"100%"}>

              <div className='districtclimaterating'>
                {/* <div className='score'><span>SCORE</span><h4>B</h4></div> */}
                <div className='dist-data space-y-0'>
                  <h5>Student Behavior</h5>

                  {
                    District_Climate_Ratingdata
                      .filter(({ METRIC_NAME }) => METRIC_NAME && !METRIC_NAME.startsWith("#") && !METRIC_NAME.includes("incidents"))
                      .map((item, index) => {
                        return (<div className='border-b-[1px] border-[#2c4089]' key={index}>
                          <div className='grid grid-cols-12 mb-[5px] mt-[5px]'>
                            <Tooltip target=".custom-target-icon" />
                            <div className='col-span-10'><div className="flex custom-target-icon" {...TooltipAttributes1({ Description: item?.METRIC_DESCRIPTION })}><p style={{ fontSize: "14px" }}>{item?.METRIC_NAME === "Referral rates" ? "# of Students with Referrals" : item?.METRIC_NAME === "RLC rate" ? "RLC Rate" : item?.METRIC_NAME}</p></div></div>
                            <ValueTooltip heading={item?.METRIC_NAME === "Referral rates" ? "# of Students with Referrals" : item?.METRIC_NAME === "RLC rate" ? "RLC Rate" : item?.METRIC_NAME} value1={item?.METRIC_NAME === "Referral rates" ? item?.METRIC_NUMERATOR.toFixed(0) : item?.METRIC_NUMERATOR.toFixed(1) + " %"} value2={item?.PERCENTAGE}>
                            <div className='col-span-2'><p style={{ fontSize: "14px" }}>{item?.METRIC_NAME === "Referral rates" ? item?.METRIC_NUMERATOR.toFixed(0) : item?.METRIC_NUMERATOR.toFixed(1) + " %"}</p></div>
                            </ValueTooltip>
                          </div>
                        </div>

                        )
                      })
                  }


                </div>
              </div>
            </LoaderContainer>
          </div>
          <div className='col-span-4 lg:col-span-4 md:col-span-6 sm:col-span-12 max-sm:col-span-12'>
            <LoaderContainer loading={District_Climate_RatingLoading} height={"100px"} width={"100%"}>

              <div className='districtclimaterating'>
                {/* <div className='score'><span>SCORE</span><h4>B</h4></div> */}
                <div className='dist-data space-y-0'>
                  <h5>Incidents</h5>

                  {
                    District_Climate_Ratingdata
                      .filter(({ METRIC_NAME }) => METRIC_NAME && METRIC_NAME.startsWith("#") && METRIC_NAME.includes("incidents"))
                      .map((item, index) => {
                        return (<div className='border-b-[1px] border-[#2c4089]' key={index}>
                          <div className='grid grid-cols-12 mb-[5px] mt-[5px]'>
                            <div className='col-span-10'><div className="flex custom-target-icon" {...TooltipAttributes1({ Description: item?.METRIC_DESCRIPTION })}><p style={{ fontSize: "14px" }}>{item?.METRIC_NAME === "Referral rates" ? "# of Students with Referrals" : item?.METRIC_NAME === "RLC rate" ? "RLC Rate" : item?.METRIC_NAME}</p></div></div>
                            <ValueTooltip heading={item?.METRIC_NAME === "Referral rates" ? "# of Students with Referrals" : item?.METRIC_NAME === "RLC rate" ? "RLC Rate" : item?.METRIC_NAME} value1={item?.METRIC_TYPE === "number" ? item?.METRIC_NUMERATOR?.toLocaleString() : item?.METRIC_NUMERATOR.toFixed(1) + " %"} value2={item?.PERCENTAGE?.toFixed(1)+'%'}>
                            <div className='col-span-2'><p style={{ fontSize: "14px" }}>{item?.METRIC_TYPE === "number" ? item?.METRIC_NUMERATOR?.toLocaleString() : item?.METRIC_NUMERATOR.toFixed(1) + " %"}</p></div>
                            </ValueTooltip>
                          </div>
                        </div>

                        )
                      })
                  }
                </div>
              </div>
            </LoaderContainer>
          </div>
        </div>
      </div>


      <div className="incidents-measures mx-4 my-4">
        <TabView>
          <TabPanel header="Incidents Summary">
            <LoaderContainer loading={Student_Behavior_Incident_Typeloading} height={"600px"} width={"100%"}>
              <div className='grid grid-cols-12 gap-4'>
                {
                  [...Student_Behavior_Incident_TypedataSorted]?.map((item, index) => {
                    return (
                      <div className='col-span-4 lg:col-span-4 md:col-span-6 sm:col-span-12 max-sm:col-span-12'>
                        <div className='incimea-box'>
                          <h4 className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: IncidentDescription[index] })}>{item?.METRIC_NAME}</h4>
                          <div className='flex px-4 items-center'>
                            <div className=''><p>{item?.NUMERATOR?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                            {
                              item?.VARIANCE < 0 ? <div className='uptolastyup'><img src={CaretarrowDown} className="" /> {item?.VARIANCE}%</div> :
                                <div className='uptolasty'><img src={CaretarrowUp} className="" /> {item?.VARIANCE}%</div>
                            }
                            <div style={{ fontSize: "12.5px", position: "relative", left: "5px" }}>Last Year Variance Comparison</div>
                          </div>
                          <div className='echartMediumLevellineArea'><ReactEcharts option={generateChartConfig(Student_Behavior_Chartdatanew, item?.METRIC_NAME)} style={{ height: '100%', width: '100%', }} /></div>
                        </div>
                      </div>

                    )
                  })
                }
              </div>
            </LoaderContainer>
          </TabPanel>
          <TabPanel header="School Performance">
            <LoaderContainer loading={student_behavior_top_performing_schoolsloading} height={"600px"} width={"100%"}>
              <div className=''>
                <div className='grid grid-cols-12 gap-4'>
                  <div className='col-span-6 lg:col-span-6 md:col-span-6 sm:col-span-12 max-sm:col-span-12'>
                    <div className='performingschools bg-[#0F0D0B] rounded-md'>
                      <h4 className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Schools with highest number of incidents" })}>Poorly Performing Schools</h4>
                      <table class="table-auto">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "14px" }}>School Name</th>
                            <th style={{ fontSize: "14px" }}>Number of Incidents</th>
                            {/* <th>Measures Taken</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {currentData && currentData?.map(itr => {

                            return (
                              <tr>
                                <td><p style={{ fontSize: "13.5px" }}>{itr?.SCHOOL_OFFICIAL_NAME}</p></td>
                                <td>
                                  <Tooltip target=".custom-target-icon" />
                                  <div className='flex gap-4'>
                                    <ValueTooltip heading={itr?.SCHOOL_OFFICIAL_NAME} value1={itr?.INCIDENT?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} value2={itr?.PERCENTAGE?.toFixed(1)+'%'}>
                                    <div className='' style={{ fontSize: "13.5px" }}>{itr?.INCIDENT?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                                    </ValueTooltip>
                                    {
                                      itr?.VARIANCE > 0 ? <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingdown'> <img src={TreadingarrowUp} className="" />{(itr?.VARIANCE).toFixed(1)}%</div></div> :
                                        itr?.VARIANCE == 0 ? <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingup'> <img src={TreadingarrowUp} className="" />{(itr?.VARIANCE).toFixed(1)}%</div></div> :
                                          <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingup'> <img src={TreadingarrowDown} className="" />{(itr?.VARIANCE).toFixed(1)}%</div></div>
                                    }
                                    <div style={{ fontSize: "12.5px" }}>Last Year Variance Comparison</div>
                                  </div>
                                  
                                </td>
                                {/* <td>
                                    <div className='flex gap-2 items-center'>
                                      <div className=''><p>2</p></div>
                                      <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                                      <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                                    </div>
                                  </td> */}
                              </tr>
                            )
                          })}
                          {/* <tr>
                          <td><p>Green Cove Springs Junior High</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>220</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -17</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>2</p></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Orange Park Junior High</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>223</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -23</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>2</p></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                              <div className=''><img src={FacultyBadges} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Charles E. Bennett Elementary</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>227</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -10</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>4</p></div>
                              <div className=''><img src={RandomdogSniff} className="" width="10" /></div>
                              <div className=''><img src={StudentIDs} className="" width="10" /></div>
                              <div className=''><img src={FacultyBadges} className="" width="10" /></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Grove Park Elementary</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>227</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -25</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>1</p></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Lakeside Junior High</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>231</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -5</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>3</p></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                              <div className=''><img src={SecurityCameras} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr> */}
                        </tbody>
                      </table>
                      {/* <div className='pagenation flex justify-around'>
                      <div className=''><Link>Previous</Link></div>
                      <div className='pageinput'>Page <input type="number" aria-label="Current Page" value="1"></input> of <span>2</span></div>
                      <div className=''><Link>Next</Link></div>
                    </div> */}
                      <div className='pagenation flex justify-around py-[5px] items-center'>
                        <button className={`paginationprevious1 ${currentPage === 1 ? 'disabled' : ''}`} onClick={handlePrevPage} disabled={currentPage === 1}><div className="previousstyle">Previous</div></button>
                        {/* <div className='pageinput'>Page {startIndex} of <span>{endIndex}</span></div> */}
                        <div className='pageinput' style={{ position: "relative", fontSize: "10px" }}>Page
                          {/* <input type="number" aria-label="Current Page" value="1"></input>  */}
                          <span> {currentPage}</span>
                          of <span>{totalPages}</span></div>
                        <button className={`paginationnext1 ${currentPage === totalPages ? 'disabled' : ''}`} onClick={handleNextPage} disabled={currentPage === totalPages}><div className="previousstyle">Next</div></button>
                      </div>
                    </div>
                  </div>
                  <div className='col-span-6 lg:col-span-6 md:col-span-6 sm:col-span-12 max-sm:col-span-12'>
                    <div className='performingschools bg-[#0F0D0B] rounded-md'>
                      <h4 className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Schools with least number of incidents" })}>Top Performing Schools</h4>
                      <table class="table-auto">
                        <thead>
                          <tr>
                            <th style={{ fontSize: "14px" }}>School Name</th>
                            <th style={{ fontSize: "14px" }}>Number of Incidents</th>
                            {/* <th>Measures Taken</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {currentData1 && currentData1?.map(itr => {
                            return (
                              <tr>
                                <td><p style={{ fontSize: "13.5px" }}>{itr?.SCHOOL_OFFICIAL_NAME}</p></td>
                                <td>
                                  <Tooltip target=".custom-target-icon" />
                                  <div className='flex gap-4'>
                                    <ValueTooltip heading={itr?.SCHOOL_OFFICIAL_NAME} value1={itr?.INCIDENT?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} value2={itr?.PERCENTAGE?.toFixed(1)+'%'}>
                                    <div className='' style={{ fontSize: "13px" }}>{itr?.INCIDENT?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                                    </ValueTooltip>
                                    {
                                      itr?.VARIANCE > 0 ? <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingdown'> <img src={TreadingarrowUp} className="" />{(itr?.VARIANCE).toFixed(1)}% </div></div> :
                                        itr?.VARIANCE == 0 ? <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingup'> <img src={TreadingarrowUp} className="" />{(itr?.VARIANCE).toFixed(1)}%</div></div> :
                                        <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.NUMERATOR_PY1 })}><div className='trendingup'> <img src={TreadingarrowDown} className="" />{(itr?.VARIANCE).toFixed(1)}% </div></div>
                                    }
                                    <div style={{ fontSize: "12.5px" }}>Last Year Variance Comparison</div>
                                    </div>
                                </td>
                                {/* <td>
                                    <div className='flex gap-2 items-center'>
                                      <div className=''><p>2</p></div>
                                      <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                                      <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                                    </div>
                                  </td> */}
                              </tr>
                            )
                          })}
                          {/* <tr>
                          <td><p>Orange Park Elementary</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>259</div>
                              <div className='trendingup'> <img src={TreadingarrowUp} className="" /> -5</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>2</p></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                              <div className=''><img src={SecurityCameras} className="" width="10" /></div>
                              <div className=''><img src={FacultyBadges} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>W.E. Cherry Elementary</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>259</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -4</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>3</p></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                              <div className=''><img src={RandomdogSniff} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Orange Park High</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>242</div>
                              <div className='trendingup'> <img src={TreadingarrowUp} className="" /> -14</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>5</p></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                              <div className=''><img src={StudentIDs} className="" width="10" /></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                              <div className=''><img src={RandomdogSniff} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Middleburg High</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>238</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -2</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>2</p></div>
                              <div className=''><img src={StudentIDs} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td><p>Clay High School</p></td>
                          <td>
                            <div className='flex gap-4'>
                              <div className=''>234</div>
                              <div className='trendingdown'> <img src={TreadingarrowDown} className="" /> -22</div>
                            </div>
                          </td>
                          <td>
                            <div className='flex gap-2 items-center'>
                              <div className=''><p>3</p></div>
                              <div className=''><img src={StrictdressCode} className="" width="10" /></div>
                              <div className=''><img src={StudentIDs} className="" width="10" /></div>
                              <div className=''><img src={ControlledaccessSchools} className="" width="10" /></div>
                              <div className=''><img src={MetaldetectorChecks} className="" width="10" /></div>
                            </div>
                          </td>
                        </tr> */}
                        </tbody>
                      </table>
                      {/* <div className='pagenation flex justify-around'>
                      <div className=''><Link>Previous</Link></div>
                      <div className='pageinput'>Page <input type="number" aria-label="Current Page" value="1"></input> of <span>2</span></div>
                      <div className=''><Link>Next</Link></div>
                    </div> */}
                      {/* <div className='pagenation flex justify-around'>
                      <div className='' onClick={handlePrevPage1} disabled={currentPage1 === 1}><Link>Previous</Link></div>
                      <div className='pageinput'>Page <input type="number" aria-label="Current Page" value="1"></input> of <span>2</span></div>
                      <div className='' onClick={handleNextPage1} disabled={currentPage1 === totalPages1}><Link>Next</Link></div>
                    </div> */}

                      <div className='pagenation flex justify-around py-[5px] items-center'>
                        <button className={`paginationprevious1 ${currentPage1 === 1 ? 'disabled' : ''}`} onClick={handlePrevPage1} disabled={currentPage1 === 1}><div className="previousstyle">Previous</div></button>
                        {/* <div className='pageinput'>Page {startIndex} of <span>{endIndex}</span></div> */}
                        <div className='pageinput' style={{ position: "relative", fontSize: "10px" }}>Page
                          {/* <input type="number" aria-label="Current Page" value="1"></input>  */}
                          <span disabled={currentPage1 === 1}> {currentPage1}</span>
                          of <span disabled={currentPage1 === totalPages1}>{totalPages1}</span></div>
                        <button className={`paginationnext1 ${currentPage1 === totalPages1 ? 'disabled' : ''}`} onClick={handleNextPage1} disabled={currentPage1 === totalPages1}><div className="previousstyle">Next</div></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LoaderContainer>
          </TabPanel>
        </TabView>
      </div>
      <div className="py-4 flex justify-end">
                    <div className="flex items-end">
                        <span className="text-white">Powered By </span>
                        <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                    </div>
                    </div>

    </div>
  )
}

